import clsx from "clsx";
import { Link as RouterLink } from "react-router-dom";
import styles from "./link.module.scss";
import LinkProps from "./@types/LinkProps";

const Link = ({
  variant,
  classification,
  baseDecoration,
  hoverDecoration,
  to,
  href,
  className,
  children,
  disabled,
  ...props
}: LinkProps) => {
  const defaultVariantClassName = to || href ? "navigation" : "action";

  const linkClassNames = clsx(
    styles.linkComponent,
    className,
    styles[`link-variant-${variant ?? defaultVariantClassName}`],
    baseDecoration && styles[`link-base-decoration-${baseDecoration}`],
    hoverDecoration && styles[`link-hover-decoration-${hoverDecoration}`],
    classification && styles[`link-classification-${classification}`],
    disabled && styles[`link-disabled`]
  );

  if (href) {
    return (
      <a href={href} className={linkClassNames} {...props}>
        {children}
      </a>
    );
  }

  if (to) {
    return (
      <RouterLink to={to} className={linkClassNames} {...props}>
        {children}
      </RouterLink>
    );
  }

  return (
    <span className={linkClassNames} {...props}>
      {children}
    </span>
  );
};

export default Link;
